module.exports = __webpack_public_path__ + "img/zimala.1ca10162.jpg";